var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.953,
    height: 42.839,
    viewBox: "0 0 32.953 42.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15884",
    "data-name": "Group 15884",
    transform: "translate(-32.655 0.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M92.173,9.025a.837.837,0,0,0-.245-.591L83.609.115a.837.837,0,0,0-.592-.245H60.057a.837.837,0,0,0-.837.837V41.872a.837.837,0,0,0,.837.837H91.336a.837.837,0,0,0,.837-.837Z",
    transform: "translate(-26.565)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M352.768,8.817a.826.826,0,0,0-.218-.383L344.232.115a.837.837,0,0,0-.592-.245V7.812a1,1,0,0,0,1,1Z",
    transform: "translate(-287.187 0)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M62.114,253.333h-31.5a.788.788,0,0,1-.729-.837v-12.83a.788.788,0,0,1,.729-.837h31.5a.788.788,0,0,1,.729.837V252.5a.9.9,0,0,1-.213.592.685.685,0,0,1-.516.245Z",
    transform: "translate(2.766 -218.966)",
    fill: "#29abe1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15883",
    "data-name": "Group 15883",
    transform: "translate(37.509 24.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M117.419,301.592a.71.71,0,0,1-.184-.527v-4.479a.643.643,0,0,1,.711-.711h1.692a3.712,3.712,0,0,1,1.687.356,2.518,2.518,0,0,1,1.088,1.017,3.131,3.131,0,0,1,.377,1.574,3.251,3.251,0,0,1-.372,1.59,2.458,2.458,0,0,1-1.08,1.017,3.769,3.769,0,0,1-1.7.351h-1.7a.713.713,0,0,1-.527-.187Zm2.109-1.054a1.776,1.776,0,0,0,1.294-.423,2.149,2.149,0,0,0,0-2.582,1.79,1.79,0,0,0-1.294-.418h-.753v3.424Z",
    transform: "translate(-117.231 -295.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M194.206,300.7a2.538,2.538,0,0,1-1.026-1.054,3.752,3.752,0,0,1,0-3.206,2.515,2.515,0,0,1,1.026-1.051,3.53,3.53,0,0,1,3.139,0,2.488,2.488,0,0,1,1.021,1.053,3.771,3.771,0,0,1,0,3.206,2.538,2.538,0,0,1-1.026,1.054,3.468,3.468,0,0,1-3.13,0Zm2.616-1.28a2.173,2.173,0,0,0,.377-1.377,2.138,2.138,0,0,0-.381-1.373,1.265,1.265,0,0,0-1.042-.469,1.291,1.291,0,0,0-1.047.464,2.715,2.715,0,0,0,0,2.759,1.4,1.4,0,0,0,2.093,0Z",
    transform: "translate(-186.496 -295.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M273.854,300.753a2.529,2.529,0,0,1-1.03-1.054,3.712,3.712,0,0,1,0-3.206,2.536,2.536,0,0,1,1.03-1.055,3.42,3.42,0,0,1,3.42.192.656.656,0,0,1,.2.218.639.639,0,0,1,.063.3.678.678,0,0,1-.146.44.446.446,0,0,1-.356.18.64.64,0,0,1-.226-.038,1.349,1.349,0,0,1-.234-.121,2.363,2.363,0,0,0-.552-.251,1.912,1.912,0,0,0-.535-.075,1.346,1.346,0,0,0-1.109.448,2.74,2.74,0,0,0,0,2.729,1.342,1.342,0,0,0,1.109.448,1.507,1.507,0,0,0,.485-.084c.156-.053.357-.136.6-.247.117-.062.2-.1.259-.126a.555.555,0,0,1,.2-.033.444.444,0,0,1,.356.18.676.676,0,0,1,.146.439.642.642,0,0,1-.063.3.635.635,0,0,1-.2.222,3.429,3.429,0,0,1-3.42.2Z",
    transform: "translate(-259.472 -295.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M341.911,300.61a.669.669,0,0,1-.222.5.7.7,0,0,1-.5.214.654.654,0,0,1-.51-.251l-1.44-1.724-1.461,1.719a.649.649,0,0,1-.5.251.694.694,0,0,1-.5-.218.682.682,0,0,1-.222-.5.69.69,0,0,1,.176-.452l1.607-1.858-1.565-1.816a.694.694,0,0,1-.184-.453.669.669,0,0,1,.222-.5.712.712,0,0,1,.507-.213.659.659,0,0,1,.51.251l1.415,1.673,1.406-1.673a.61.61,0,0,1,.494-.251.71.71,0,0,1,.506.213.669.669,0,0,1,.222.5.691.691,0,0,1-.176.453l-1.565,1.816,1.6,1.858A.681.681,0,0,1,341.911,300.61Z",
    transform: "translate(-318.2 -295.286)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.f7e9a11b15c2f1971cef1cf68f13990a.svg";
export { ForwardRef as ReactComponent };